import { IShopInfo } from '@/model/types/shop'
import { IShopPayment } from './api'

export const canUploadReceiptImage = (shopVersion?: number) => shopVersion != null && shopVersion !== 0

export const countActivePayments = (payment: IShopPayment) =>
    payment.paymentconfig.payment_list.length + payment.custom_payment_config.filter(item => item.status === 1).length

export const buildSeatPaymentUrl = (center: string, shop: IShopInfo, feeCode: number, count: number) => {
    const params = new URLSearchParams({
        shop_id: String(shop.id),
        shop_type: 'new_ls',
        fee_code: String(feeCode),
        count: String(count),
        shop_super_admin_passport_id: String(shop.creator?.passport_id || ''),
    })

    return `${center}/#/main/paymentCenter?${params.toString()}`
}
